<template>
    <div class="components-view">
        <main class="current-component vr-align-center">
            <vuescroll>
                <div class="authorization-box">
                    <img :src="require('Assets/auth-logo.png')" class="logo" alt=""/>
                    <p class="box-title">Мы рады, что ты с нами!<br/>Войди в систему и оставайся!</p>
                    <candidate-login-form v-if="this.type === 'candidate'"></candidate-login-form>
                    <user-login-form v-else></user-login-form>
                </div>
            </vuescroll>
        </main>
    </div>
</template>

<script>
    import vuescroll from 'vuescroll';
    import UserLoginForm from "./UserLoginForm";
    import CandidateLoginForm from "./CandidateLoginForm";

    export default {
        name: 'authorization-component',
        components: {
            CandidateLoginForm,
            UserLoginForm,
            vuescroll
        },
        data() {
            return {
                type: 'user',
            }
        },
        created() {
            let token = this.$route.query.token;
            if(token) {
                this.type = 'candidate'
            }
            this.$store.commit('setAppClass', 'introductory-view');
        }
    }
</script>


<style scoped>

</style>
